import { render, staticRenderFns } from "./AgencyTypeChart.vue?vue&type=template&id=e6705f3c&"
import script from "./AgencyTypeChart.vue?vue&type=script&lang=js&"
export * from "./AgencyTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports